<template>
  <div id="contact-search">
    <input
      type="text"
      id="contact-search-input"
      placeholder="Start typing to search"
      v-model="searchTerm"
    />
    <base-list-item
      v-for="(contact, index) in results"
      :key="index"
      class="contact-search-item"
      @click="chooseContact(contact)"
      ><contact-name-and-photo :contact="contact"
    /></base-list-item>
  </div>
</template>
<script>
import BaseListItem from "../../UI/ListItems/BaseListItem.vue";
import ContactNameAndPhoto from "../../UI/ListItems/ListItemComponents/ContactNameAndPhoto.vue";
export default {
  data() {
    return {
      searchTerm: undefined,
      tenants: [],
    };
  },
  computed: {
    role() {
      return this.$store.getters.userRole;
    },
    results() {
      return this.contacts.filter((x) => {
        if (this.searchTerm) {
          return (
            x.given_name.toLowerCase().includes(this.searchTerm) ||
            x.family_name.toLowerCase().includes(this.searchTerm) ||
            x.email.toLowerCase().includes(this.searchTerm)
          );
        } else {
          return true;
        }
      });
    },
    contacts() {
      if (this.role === "admin") {
        return this.$store.getters.contacts;
      } else {
        let events = this.$store.getters.events();

        let eventContacts = [];
        events.forEach((event) => {
          let contacts = event.contacts.map((x) => {
            return typeof x === "string"
              ? { userId: x, tenantId: event.tenantId }
              : x.key
              ? x.key
              : x;
          });
          eventContacts.push(
            ...contacts.filter((subject) => {
              return (
                eventContacts.findIndex((x) => {
                  return x.userId === subject.userId;
                }) === -1
              );
            })
          );
        });
        return [...this.tenants, ...eventContacts];
      }
    },
  },
  methods: {
    chooseContact(contact) {
      this.$emit("select-contact", contact);
    },
    async getTenants() {
      let user = this.$store.state.user;
      let tenants = user.tenants ? user.tenants : [];
      if (!tenants.includes(user.tenantId)) {
        tenants.push(user.tenantId);
      }
    },
  },
  components: {
    BaseListItem,
    ContactNameAndPhoto,
  },
  props: [],
  emits: ["select-contact"],
};
</script>
<style scoped>
#contact-search {
  height: 100%;
  overflow: scroll;
}
input {
  outline: none;
  border: none;
  border-bottom: 1px solid var(--shadow);
  padding: 10px 5px;
  margin: 10px 0;
  /* margin: 5px; */
  text-align: center;
  font-family: Raleway, sans-serif;
  width: 100%;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 2;
}

.contact-search-item {
  margin: 5px;
}
</style>
